import { useT } from '@/i18n';

import { CloseIcon } from './Icons';
import styles from './ChatCopiedNotice.module.css';

/**
 * The Mac app's secret chat shortcut has made this chat and put its link on the clipboard (the shell opens the chat
 * with `?copied=1`). Under the chat's head a yellow card says just that: the link is copied, send it. Its icon is the
 * copy icon from the first frame to the last, and the copy plays on it once: the sheet in front slides out of the one
 * behind, and a ring spreads from the pair (nothing moves under reduced motion). The card holds no link and no key, and
 * stays until the other device joins or it is closed.
 */
export function ChatCopiedNotice({ onClose }: { readonly onClose: () => void }): React.JSX.Element {
  const t = useT();
  return (
    <div className={styles.card} role="status" data-testid="chat-copied-notice">
      <span className={styles.icon} aria-hidden="true">
        <span className={styles.ring} />
        <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <path className={styles.back} d="M8 8V6.5A2.5 2.5 0 0 1 10.5 4h7A2.5 2.5 0 0 1 20 6.5v7a2.5 2.5 0 0 1-2.5 2.5H16" />
          <rect className={styles.front} x="4" y="8" width="12" height="12" rx="2.5" />
        </svg>
      </span>
      <div className={styles.words}>
        <p className={styles.title}>{t('chatCopied.title')}</p>
        <p className={styles.text}>{t('chatCopied.text')}</p>
      </div>
      <button type="button" className={styles.close} onClick={onClose} aria-label={t('chatCopied.dismiss')} title={t('chatCopied.dismiss')} data-testid="chat-copied-close">
        <CloseIcon size={16} />
      </button>
    </div>
  );
}
